// extracted by mini-css-extract-plugin
module.exports = {"divContainer":"YoutubeVideoPreview__divContainer___kqPXM","iframe":"YoutubeVideoPreview__iframe___3SG5N"};